module.exports = __webpack_public_path__ + "fonts/Inter-SemiBold.1db6c55.woff";